// src/pages/HomePage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTeamContext } from "../TeamContext";
import TopBar from "../ui/TopBar";
import { Check, X, Edit, Copy, Trash2, Undo2, Plus, PenLine } from "lucide-react";
import "../styles.css";

function WorkspaceItem({
                           ws,
                           equity,
                           onRename,
                           onDelete,
                           onDuplicate,
                           setActiveWorkspaceId,
                           navigate
                       }) {
    const [renaming, setRenaming] = useState(false);
    const [newName, setNewName] = useState(ws.name);
    const [isDuplicating, setIsDuplicating] = useState(false);
    const [duplicateName, setDuplicateName] = useState("");
    const part1 = ws.part1Answers || {};
    const createdDate = new Date(ws.createdAt);
    const founders = part1.founderNames || [];

    const handleRename = () => {
        if (newName.trim()) {
            onRename(ws, newName.trim());
            setRenaming(false);
        }
    };

    return (
        <div
            style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "16px",
                margin: "16px 0",
                backgroundColor: "#ffffff",
                color: "#28435a"
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ flexGrow: 1 }}>
                    <div style={{ marginBottom: "12px" }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {renaming ? (
                                <>
                                    <input
                                        value={newName}
                                        onChange={(e) => setNewName(e.target.value)}
                                        style={{
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            border: "1px solid #ddd",
                                            color: "#28435a"
                                        }}
                                    />
                                    <button
                                        onClick={handleRename}
                                        style={{
                                            padding: "4px 8px",
                                            backgroundColor: "#02a1bc", /* or #f7931e if you prefer */
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Save
                                    </button>
                                </>
                            ) : (
                                <>
                                    <h3
                                        style={{ margin: "0", cursor: "pointer" }}
                                        onClick={() => {
                                            setActiveWorkspaceId(ws.id);
                                            navigate(`/calculator?workspace=${ws.id}`);
                                        }}
                                    >
                                        {ws.name}
                                    </h3>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setRenaming(true);
                                        }}
                                        style={{
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            padding: "4px"
                                        }}
                                    >
                                        <PenLine size={14} color="#28435a" />
                                    </button>
                                </>
                            )}
                        </div>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "12px",
                            color: "#28435a"
                        }}
                    >
                        {part1.companyName && (
                            <div style={{ fontSize: "0.9rem" }}>
                                {part1.companyName}
                            </div>
                        )}
                        <div style={{ fontSize: "0.9rem" }}>
                            {createdDate.toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                            })}
                        </div>
                    </div>
                    <div style={{ color: "#28435a" }}>
                        {founders.length > 0 ? (
                            founders.map(fn => (
                                <span
                                    key={fn}
                                    style={{
                                        marginRight: "24px",
                                        cursor: "pointer",
                                        padding: "4px 0px",
                                        borderRadius: "4px"
                                    }}
                                    onClick={() => {
                                        setActiveWorkspaceId(ws.id);
                                        navigate("/report");
                                    }}
                                >
                                    {fn}: <strong>{equity[fn]}%</strong>
                                </span>
                            ))
                        ) : "No founders added"}
                    </div>
                </div>

                {isDuplicating ? (
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <input
                            type="text"
                            value={duplicateName}
                            onChange={(e) => setDuplicateName(e.target.value)}
                            placeholder="Workspace name"
                            style={{
                                padding: "4px 8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                color: "#28435a"
                            }}
                        />
                        <button
                            onClick={() => {
                                onDuplicate(ws, duplicateName.trim());
                                setIsDuplicating(false);
                                setDuplicateName("");
                            }}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px"
                            }}
                        >
                            <Check size={16} color="#02a1bc" />
                        </button>
                        <button
                            onClick={() => {
                                setIsDuplicating(false);
                                setDuplicateName("");
                            }}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px"
                            }}
                        >
                            <X size={16} color="#df1c1c" />
                        </button>
                    </div>
                ) : (
                    <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                        <button
                            onClick={() => navigate(`/calculator?workspace=${ws.id}`)}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px"
                            }}
                        >
                            <Edit size={16} color="#28435a" />
                        </button>
                        <button
                            onClick={() => {
                                setIsDuplicating(true);
                                setDuplicateName(`Copy of ${ws.name}`);
                            }}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px"
                            }}
                        >
                            <Copy size={16} color="#02a1bc" />
                        </button>
                        <button
                            onClick={() => onDelete(ws)}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px"
                            }}
                        >
                            <Trash2 size={16} color="#df1c1c" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

function HomePage() {
    const navigate = useNavigate();
    const { workspaces, addWorkspace, setActiveWorkspaceId, updateWorkspaceData } = useTeamContext();
    const [deletedEntry, setDeletedEntry] = useState(null);
    const [showHelpPanel, setShowHelpPanel] = useState(false);
    const [isAddingWorkspace, setIsAddingWorkspace] = useState(false);
    const [newWorkspaceName, setNewWorkspaceName] = useState("");

    const handleDuplicate = (originalWs, newName) => {
        if (newName.trim()) {
            const newWs = addWorkspace(newName.trim());
            updateWorkspaceData(newWs.id, {
                ...newWs,
                part1Answers: { ...originalWs.part1Answers },
                part2Answers: { ...originalWs.part2Answers },
            });
        }
    };

    const calculateEquityPercentages = (part1, part2) => {
        try {
            const founderNames = part1?.founderNames || [];
            if (founderNames.length === 0) return {};

            const R_FI = part1.ratingFinancialImpact || 3;
            const R_TC = part1.ratingTimeImportance || 3;
            const R_AI = part1.ratingAssetImportance || 3;
            const totalRatings = R_FI + R_TC + R_AI;

            const cashTotal = Object.values(part1.foundersCashInvested || {}).reduce((a, b) => a + (b || 0), 0);
            const timeTotal = Object.values(part1.foundersTime || {}).reduce((a, b) => a + (b || 0), 0);
            const assetsTotal = Object.values(part1.foundersAssets || {}).reduce((a, b) => a + (b || 0), 0);

            const reservedPools = part1.reservedPools || [];
            const reservedTotal = reservedPools.reduce((sum, pool) => sum + (pool.weight || 0), 0);

            const factors = [
                ...(part2.coreFactors || []),
                ...(part2.preFormation || []),
                ...(part2.roleResponsibility || []),
                ...(part2.experienceNetworks || [])
            ];

            const factorAllocations = {};
            founderNames.forEach(fn => {
                factorAllocations[fn] = factors.reduce((sum, factor) =>
                    sum + (parseFloat(factor.allocations?.[fn] || 0) || 0), 0
                );
            });

            const totalAllocations = founderNames.reduce((sum, fn) => sum + factorAllocations[fn], 0);
            const availableEquity = Math.max(100 - reservedTotal - totalAllocations, 0);

            const percentages = {};
            founderNames.forEach(fn => {
                const cash = cashTotal > 0 ? (part1.foundersCashInvested[fn] || 0) / cashTotal : 0;
                const time = timeTotal > 0 ? (part1.foundersTime[fn] || 0) / timeTotal : 0;
                const assets = assetsTotal > 0 ? (part1.foundersAssets[fn] || 0) / assetsTotal : 0;

                const coreEquity = ((cash * R_FI + time * R_TC + assets * R_AI) / totalRatings) * availableEquity;
                percentages[fn] = Math.round(coreEquity + (factorAllocations[fn] || 0));
            });

            return percentages;
        } catch (error) {
            console.error("Equity calculation error:", error);
            return {};
        }
    };

    const handleCreateWorkspace = () => {
        if (newWorkspaceName.trim()) {
            const newWs = addWorkspace(newWorkspaceName.trim());
            setActiveWorkspaceId(newWs.id);
            setIsAddingWorkspace(false);
            setNewWorkspaceName("");
        }
    };

    const handleDelete = (ws) => {
        setDeletedEntry({ ...ws });
        updateWorkspaceData(ws.id, { ...ws, _deleted: true });
    };

    const handleUndoDelete = () => {
        if (deletedEntry) {
            updateWorkspaceData(deletedEntry.id, { ...deletedEntry, _deleted: false });
            setDeletedEntry(null);
        }
    };

    return (
        <div className="wrapper">
            {/* Floating help button */}
            <div style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 9999
            }}>
                {showHelpPanel && (
                    <div style={{
                        backgroundColor: "#FAFAFA",
                        border: "1px solid #ccc",
                        padding: "16px",
                        borderRadius: "6px",
                        width: "280px",
                        color: "#28435a"
                    }}>
                        <p style={{ fontWeight: 600, marginBottom: "12px" }}>
                            Workspace Help
                        </p>
                        <p>Toggle between workspaces or create new ones.</p>
                        <p>Click founder percentages to jump to their breakdown.</p>
                    </div>
                )}
                <button
                    onClick={() => setShowHelpPanel(!showHelpPanel)}
                    style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#28435a", /* teal for help/info */
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "18px",
                    }}
                >
                    ?
                </button>
            </div>

            {deletedEntry && (
                <div style={{ margin: "16px 0" }}>
                    <button className="transparent-button" onClick={handleUndoDelete}>
                        <Undo2 size={14} style={{ marginRight: "8px" }} />
                        Undo Delete
                    </button>
                </div>
            )}

            <h1>Workspaces</h1>

            <div className="section">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h2>Your Workspaces</h2>
                    {!isAddingWorkspace ? (
                        <button
                            onClick={() => setIsAddingWorkspace(true)}
                            className="add-workspace-btn"
                            style={{ marginTop: "16px", display: "flex", alignItems: "center", gap: "8px" }}
                        >
                            <Plus size={16} />
                            Add Workspace
                        </button>
                    ) : (
                        <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
                            <input
                                type="text"
                                value={newWorkspaceName}
                                onChange={(e) => setNewWorkspaceName(e.target.value)}
                                placeholder="Workspace name"
                                style={{
                                    padding: "8px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    color: "#28435a"
                                }}
                            />
                            <button
                                onClick={handleCreateWorkspace}
                                style={{
                                    backgroundColor: "#f7931e",
                                    color: "white",
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer"
                                }}
                            >
                                Create
                            </button>
                            <button
                                onClick={() => setIsAddingWorkspace(false)}
                                style={{
                                    backgroundColor: "#ccc",
                                    color: "#28435a",
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>

                {workspaces
                    .filter(ws => !ws._deleted)
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    .map(ws => (
                        <WorkspaceItem
                            key={ws.id}
                            ws={ws}
                            equity={calculateEquityPercentages(ws.part1Answers || {}, ws.part2Answers || {})}
                            onRename={(ws, newName) => updateWorkspaceData(ws.id, { ...ws, name: newName })}
                            onDelete={handleDelete}
                            onDuplicate={handleDuplicate}
                            setActiveWorkspaceId={setActiveWorkspaceId}
                            navigate={navigate}
                        />
                    ))}
            </div>
        </div>
    );
}

// In HomePage.js
export const getServerSideProps = () => {
    // In a real app this would load from localStorage on server,
    // but for client-side only we'll return empty workspaces
    return { props: { workspaces: [] } };
};

export default HomePage;
